import { render } from "./Thumbnails.vue?vue&type=template&id=06fb0c88&scoped=true&ts=true"
import script from "./Thumbnails.vue?vue&type=script&lang=ts"
export * from "./Thumbnails.vue?vue&type=script&lang=ts"

import "./Thumbnails.vue?vue&type=style&index=0&id=06fb0c88&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fb0c88"]])

export default __exports__